import React from "react";
import { Tooltip } from "@blueprintjs/core";
import { getProgressStatusForGoal } from "../../utils/goalProgressUtils.js";

const GoalProgressStatusBadge = ({ goal, style = {} }) => {
  if (!goal) return null;

  const status = getProgressStatusForGoal(goal);

  return (
    <Tooltip content={status.meaning} placement="top" portalContainer={document.body}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: status.background,
          color: status.color,
          border: `1px solid ${status.color}`,
          borderRadius: "20px",
          padding: "4px 12px",
          marginLeft: "10px",
          fontSize: "13px",
          fontWeight: 500,
          whiteSpace: "nowrap",
          ...style
        }}
      >
        {status.label}
      </span>
    </Tooltip>
  );
};

export default GoalProgressStatusBadge;
